/* Signature - single-attempt cart mutation classification.
   Ambiguous outcomes are never retried because Shopify may have accepted them. */
(function (global) {
  'use strict';

  async function requestAdd(form, dependencies) {
    const deps = dependencies || {};
    const request = deps.fetch || global.fetch;
    const timeoutMs = deps.timeoutMs === undefined ? 15000 : deps.timeoutMs;
    const AbortControllerImpl = deps.AbortController || global.AbortController;
    const controller = AbortControllerImpl ? new AbortControllerImpl() : null;
    const schedule = deps.setTimeout || global.setTimeout;
    const cancel = deps.clearTimeout || global.clearTimeout;
    let timeout;

    if (controller && timeoutMs > 0) {
      timeout = schedule(() => controller.abort(), timeoutMs);
    }

    try {
      const response = await request('/cart/add.js', {
        method: 'POST',
        body: deps.formData ? deps.formData(form) : new global.FormData(form),
        headers: { Accept: 'application/json' },
        ...(controller ? { signal: controller.signal } : {}),
      });
      if (response.ok) return { status: 'accepted' };
      if (response.status >= 400 && response.status < 500 && response.status !== 408) {
        return { status: 'rejected' };
      }
      return { status: 'unknown' };
    } catch (error) {
      return { status: 'unknown' };
    } finally {
      if (timeout !== undefined) cancel(timeout);
    }
  }

  global.SignatureCart = { requestAdd };
})(typeof window === 'undefined' ? globalThis : window);
